(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-cookie-preferences]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0 || !window.privacyBanner?.showPreferences) return;
    event.preventDefault();
    Promise.resolve(window.privacyBanner.showPreferences()).catch(() => window.location.assign(link.href));
  });

  } catch(e) { console.error(e); }
})();
})();
